import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetCrecaTradesService } from "@/features/accounts/creca/services/get-trades-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { CrecaTradeInfo } from "@/features/accounts/creca/services/get-trades-model";


export const useGetCrecaTrades = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getCrecaTradesService = new GetCrecaTradesService();

  // クレカ明細一覧取得
  const getCrecaTrades = async (
    accountGroupId: string,
    crecaAccountId: string,
    startDate?: string,
    endDate?: string,
  ) :Promise<CrecaTradeInfo[]> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getCrecaTradesService.getCrecaTrades({
        account_group_id:  accountGroupId,
        creca_account_id: crecaAccountId,
        ...(startDate !== undefined && { start_date: startDate }),
        ...(endDate !== undefined && { end_date: endDate }),
      });
      return res.transactions;
    } catch (error) {
      // エラーハンドリング
      console.log("getCrecaTrades:", error);
      throw error;
      // return [];
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getCrecaTrades: errorHandledAsync(getCrecaTrades, setError),
  };
};
